// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__20fSk","assignButton":"CreateEditEquipmentSchedule_assignButton__2Mk8m"};